import { array, number, object, string } from 'valibot';
import * as v from 'valibot';
export const CreateNewUserSchema = object({
    email: string(),
});
export const OnboardUserSchema = object({
    password: v.nullish(string()),
});
export const GetProfileParamsSchema = object({
    userId: string(),
});
export const UserSchema = object({
    id: string(),
    email: string(),
    role: string(),
    status: string(),
    created_at: string(),
});
export const GetAllUsersResponseSchema = object({
    users: array(UserSchema),
});
export const getScheduledEventNotificationsResponseSchema = object({
    totalJobs: number(),
    jobs: array(object({
        type: string(),
        jobName: string(),
        nextRun: v.nullable(string()),
        eventId: v.nullable(string()),
        notificationType: v.nullable(string()),
    })),
});
export const registerPushTokenResponseSchema = object({
    token: string(),
    platform: string(),
});
export const ErrorResponseSchema = object({
    error: string(),
});
//# sourceMappingURL=dtos.js.map